import { Injectable } from '@angular/core';
import { AuthenticationService } from '../../core/security/authentication/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  loggedFromSSO: boolean;

  constructor(private authenticationService: AuthenticationService) {}

  login(username: string, password: string) {
    return this.authenticationService.login(username, password);
  }

  logout(username: string) {
    sessionStorage.removeItem('ssoToken');
    this.authenticationService.logout(username);
  }

  loginSSO(token: string) {
    return this.authenticationService.loginSSO(token);
  }

  logoutSSO() {
    sessionStorage.removeItem('ssoToken');
    window.close();
  }
}
